import { render } from "./DefaultForm.vue?vue&type=template&id=4333ae80"
import script from "./DefaultForm.vue?vue&type=script&lang=js"
export * from "./DefaultForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__